import $ from "jquery";

const step = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-ChangeTab",
      details: ".js-DetailsTab",

    };

    if ($(el.details).length === 0) return;

    $(document).on('click', el.button, function (e) {
      e.preventDefault();
      $(el.details).attr('open', false);

      const target = $(this).data('target');
      $(`.Header__Body__Logo__Content--ReturnOldCar__SectionLink`).removeClass('active');
      $(`.Header__Body__Logo__Content--ReturnOldCar__SectionLink[data-target=${target}]`).toggleClass('active');
      $(`#section-${target}`).attr('open', true);

      let offsetLeftCurrEl = $(this).offset().left;
      if($(this).hasClass('ReturnOldCar__Button__Prev')){
        offsetLeftCurrEl = offsetLeftCurrEl.left - $(this).width();
      }else if($(this).hasClass('ReturnOldCar__Button__Next')){
        offsetLeftCurrEl = offsetLeftCurrEl +  $(this).width();
      }
      $('.Header__Body__Logo__Content__Navigation').animate({'scrollLeft': offsetLeftCurrEl}, 500);    
    });

  };

  init();
};


try {
  step();
} catch (error) {
  console.error("step: ", error);
}
